<template>
  <div>
    <v-row>
      <v-col cols="6" sm="12" md="6" lg="4" class="pb-0">
        <!-- <span class="create-label">บริษัท</span>
        <span class="create-label-red">*</span> -->
        <v-select
          v-model="companySelectThis"
          :items="companyItems"
          :item-text="companyItemsText"
          :item-value="companyItemsValue"
          outlined
          dense
          readonly
          label="เลือกบริษัท"
          class="mt-2"
        >
        </v-select>
      </v-col>
      <v-col cols="6" sm="12" md="6" lg="4" class="pb-0">
        <!-- <span class="create-label">ประเภทหัวข้อ</span>
        <span class="create-label-red">*</span> -->
        <v-select
          v-model="titleSelectThis"
          :items="titleItems"
          outlined
          dense
          :readonly="titleSelectDisable"
          label="เลือกประเภทหัวข้อ"
          class="mt-2"
        >
        </v-select>
      </v-col>
      <v-col cols="6" sm="12" md="6" lg="4" class="pb-0">
        <!-- <span class="create-label">สายบังคับบัญชา</span>
        <span class="create-label-red">*</span> -->
        <v-select
          v-model="headerSelectThis"
          :items="headerItemsThis"
          :item-text="headerItemsText"
          :item-value="headerItemsValue"
          outlined
          dense
          label="เลือกสายบังคับบัญชา"
          class="mt-2"
          :readonly="headerSelectDisable"
        >
        </v-select>
      </v-col>
    </v-row>
    <OverlayLoading :loading="loading" />
    <div v-if="!loading" class="mt-5">
      <div class="create-orgchart-roundbox-odd mt-3">
        <div class="create-orgchart-row-title">
          <span class="create-orgchart-title-odd">{{`ลำดับที่ ${orgchartLevelThis}`}}</span>
        </div>

        <div class="ml-5 mr-5">
          <div class="create-orgchart-row-title mt-2">
            <span class="create-orgchart-type-label-odd">ชื่อหัวข้อ</span>
            <v-text-field
              v-model="orgchartNameThis"
              label=""
              placeholder="ชื่อหัวข้อ"
              outlined
              dense
              class="ml-5 create-orgchart-type-textfield create-orgchart-type-label-odd"
              color="#333"
            ></v-text-field>
          </div>

          <div class="create-orgchart-row-title mt-2">
            <span
              class="create-orgchart-header-title-odd"
            >
            ข้อมูลผู้ดูแล
            </span>
            <v-switch
              v-model="haveLeadThis"
              :readonly="!orgchartNameThis || orgchartNameThis === ' ' || orgchartNameThis === '-'"
              @click="addLeader()"
              label=""
              color="#0370B7"
              class="ml-5 mt-0"
              hide-details
            ></v-switch>
          </div>

          <div v-if="haveLeadThis" class="ml-5 mt-2">
            <v-row>
              <v-col cols="6" sm="12" md="6" lg="4" class="pb-0">
                <div class="create-orgchart-row-title">
                  <span
                    class="create-orgchart-type-label-odd"
                  >
                  รหัสพนักงานของผู้ดูแล
                  </span>
                  <v-autocomplete
                    v-model="orgchartUserIdThis"
                    @change="changeLeaderData()"
                    :items="orgchartUserItemThis"
                    :item-text="orgchartUserText"
                    :item-value="orgchartUserValue"
                    :loading="orgchartLoadingUser"
                    hide-details
                    hide-selected
                    label=""
                    outlined
                    dense
                    class="ml-5 create-orgchart-type-textfield create-orgchart-type-label-odd"
                    color="#333"
                  >
                    <!-- <template v-slot:no-data>
                      <v-list-item>
                        <v-list-item-title>
                          ค้นหาพนักงานโดย
                          <strong>ชื่อสกุล หรือรหัสพนักงาน</strong>
                        </v-list-item-title>
                      </v-list-item>
                    </template> -->
                    <template v-slot:selection="{ attr, on, item, selected }">
                      <v-chip
                        v-bind="attr"
                        :input-value="selected"
                        color="#0370B7"
                        text-color="#fff"
                        v-on="on"
                      >
                        <span v-text="item.employeeId"></span>
                      </v-chip>
                    </template>
                    <template v-slot:item="{ item }">
                      <v-list-item-content>
                        <v-list-item-title v-text="item.employeeId"></v-list-item-title>
                        <v-list-item-subtitle v-text="item.name"></v-list-item-subtitle>
                        <v-list-item-subtitle v-if="item.position.positionName" v-text="item.position.positionName"></v-list-item-subtitle>
                      </v-list-item-content>
                    </template>
                  </v-autocomplete>
                </div>
              </v-col>
            </v-row>
            <v-row style="align-items: baseline;">
              <v-col cols="2" sm="12" md="2" lg="2" class="pa-0">
                <v-checkbox
                  v-model="orgchartTemporaryLeaderThis"
                  color="#0370B7"
                  label="รักษาการแทน"
                  class="create-orgchart-type-label-odd"
                >
                </v-checkbox>
              </v-col>
              <v-col cols="5" sm="12" md="5" lg="5" class="pb-0">
                <div class="create-orgchart-row-title">
                  <span
                    class="create-orgchart-type-label-odd"
                  >
                  ชื่อ-สกุลของผู้ดูแล
                  </span>
                  <v-text-field
                    readonly
                    v-model="orgchartUserNameThis"
                    label=""
                    placeholder="ชื่อ-สกุลของผู้ดูแล"
                    outlined
                    dense
                    class="ml-5 create-orgchart-type-textfield create-orgchart-type-label-odd"
                    color="#333"
                  ></v-text-field>
                </div>
              </v-col>

              <v-col cols="5" sm="12" md="5" lg="5" class="pb-0">
                <div class="create-orgchart-row-title">
                  <span
                    class="create-orgchart-type-label-odd"
                  >
                  ตำแหน่งของผู้ดูแล
                  </span>
                  <v-text-field
                    readonly
                    v-model="orgchartUserPositionThis"
                    label=""
                    placeholder="ตำแหน่งของผู้ดูแล"
                    outlined
                    dense
                    class="ml-5 create-orgchart-type-textfield create-orgchart-type-label-odd"
                    color="#333"
                  ></v-text-field>
                </div>
              </v-col>
            </v-row>
          </div>
        </div>
      </div>

      <div v-if="showInvisSaveThis" class="mt-5 create-orgchart-row-title">
        <v-spacer/>
        <v-btn color="red" dark class="create-orgchart-header-cancel-btn pa-5" @click="cancelSave()">ยกเลิก</v-btn>
        <v-btn
          color="success"
          class="ml-5 create-orgchart-header-save-btn pa-5"
          @click="saveData()"
        >บันทึก</v-btn>
      </div>
    </div>
  </div>
</template>

<script>
import {
  getUserByKeyword,
  getSelectCompanyHeader
} from '@/API/API'
import OverlayLoading from '../OverlayLoading.vue'
import { EventBus } from '@/EventBus'

export default {
  name: 'template-update-orgchart',
  components: {
    OverlayLoading
  },
  props: {
    loading: Boolean,
    orgchartId: String,
    companyItems: Array,
    companyItemsText: String,
    companyItemsValue: String,
    companySelect: String,
    titleItems: Array,
    titleSelect: String,
    titleSelectDisable: Boolean,
    headerItems: Array,
    headerItemsText: String,
    headerItemsValue: String,
    headerSelect: String,
    headerSelectDisable: Boolean,
    orgchartLevel: String,
    orgchartName: String,
    haveLead: Boolean,
    orgchartLoadingUser: Boolean,
    orgchartUserItem: Array,
    orgchartUserText: String,
    orgchartUserValue: String,
    orgchartUserId: String,
    orgchartTemporaryLeader: Boolean,
    orgchartUserEmployeeId: String,
    orgchartUserName: String,
    orgchartUserPosition: String,
    showInvisSave: Boolean
  },
  data () {
    return {
      companySelectThis: '',
      titleSelectThis: '',
      headerItemsThis: [],
      headerSelectThis: '',
      orgchartLevelThis: '',
      orgchartNameThis: '',
      haveLeadThis: false,
      orgchartUserItemThis: [],
      orgchartUserIdThis: '',
      orgchartTemporaryLeaderThis: false,
      orgchartUserEmployeeIdThis: '',
      orgchartUserNameThis: '',
      orgchartUserPositionThis: '',
      showInvisSaveThis: false,
      temp_position: {}
    }
  },
  created () {
    this.getUser()
    // this.orgchartUserItemThis = this.orgchartUserItem
    // console.log('orgchartUserItemThis: ', this.orgchartUserItemThis)
    this.companySelectThis = this.companySelect
    this.titleSelectThis = this.titleSelect
    this.headerItemsThis = this.headerItems
    this.headerSelectThis = this.headerSelect
    this.orgchartLevelThis = this.orgchartLevel
    this.orgchartNameThis = this.orgchartName
    this.haveLeadThis = this.haveLead
    this.orgchartUserIdThis = this.orgchartUserId
    this.orgchartTemporaryLeaderThis = this.orgchartTemporaryLeader
    // console.log('update: ', this.orgchartTemporaryLeader)
    this.orgchartUserEmployeeIdThis = this.orgchartUserEmployeeId
    this.orgchartUserNameThis = this.orgchartUserName
    this.orgchartUserPositionThis = this.orgchartUserPosition
    this.showInvisSaveThis = this.showInvisSave
  },
  mounted () {
    EventBus.$on('updateOrgchart-changeLeaderUser', this.changeLeaderUser)
    EventBus.$on('updateOrgchart-deleteOrgchart', this.deleteOrgchart)
  },
  watch: {
    titleSelectThis () {
      if (this.companySelectThis && this.titleSelectThis) {
        this.initItemCompanyHeader()
      }
    },
    orgchartNameThis () {
      if (this.orgchartNameThis) this.showInvisSaveThis = true
      else this.showInvisSaveThis = false
    },
    haveLeadThis () {
      if (this.orgchartNameThis && this.haveLeadThis) {
        if (this.orgchartUserNameThis) this.showInvisSaveThis = true
        else this.showInvisSaveThis = false
      } else if (this.orgchartNameThis) this.showInvisSaveThis = true
      else this.showInvisSaveThis = false
    }
  },
  methods: {
    async getUser () {
      var temp = []
      const obj = {
        search: ''
      }
      try {
        const res = await getUserByKeyword(obj, this.tokenUser)
        // console.log(res.result)
        if (res.success) {
          res.result.map(el => {
            this.temp_position = el.position
            temp.push({ ...el, position: { ...this.temp_position, positionName: el?.position?.positionName || '-' } })
          })
          this.orgchartUserItemThis = temp
        }
      } catch (error) {
        console.log(error)
      }
    },
    async initItemCompanyHeader () {
      var temp = []
      const obj = {
        companyId: this.companySelectThis,
        orgChartType: this.titleSelectThis
      }

      try {
        const res = await getSelectCompanyHeader(obj, this.tokenUser)
        if (res.success) {
          temp = res.result
          temp.push({
            _id: null,
            orgChartName: 'ไม่มี'
          })
          this.headerItemsThis = temp
        }
      } catch (error) {
        console.log(error)
      }
    },
    addLeader () {
      const data = {
        orgchartName: this.orgchartNameThis,
        haveLead: this.haveLeadThis
      }
      EventBus.$emit('updateOrgchart-changeHaveLeader', data)
    },
    changeLeaderData () {
      EventBus.$emit('updateOrgchart-changeLeader', this.orgchartUserIdThis)
    },
    changeLeaderUser (data) {
      this.orgchartUserIdThis = data.id
      this.orgchartUserNameThis = data.name
      this.orgchartUserPositionThis = data.position
      if (this.haveLeadThis) {
        if (data.id) this.showInvisSaveThis = true
        else this.showInvisSaveThis = false
      } else this.showInvisSaveThis = true
    },
    deleteOrgchart () {
      EventBus.$emit('updateOrgchart-confirmDelete')
    },
    cancelSave () {
      EventBus.$emit('updateOrgchart-cancelUpdate')
    },
    saveData () {
      const data = {
        companyId: this.companySelectThis,
        headerId: this.headerSelectThis,
        orgchartLevel: this.orgchartLevelThis,
        orgchartName: this.orgchartNameThis,
        haveLead: this.haveLeadThis,
        orgchartUserId: this.haveLeadThis ? this.orgchartUserIdThis : null,
        orgchartTemporaryLeader: this.haveLeadThis ? this.orgchartTemporaryLeaderThis : false,
        orgchartUserName: this.haveLeadThis ? this.orgchartUserName : null,
        orgchartUserPosition: this.haveLeadThis ? this.orgchartUserPositionThis : null
      }
      EventBus.$emit('updateOrgchart-saveUpdate', data)
    }
  }
}
</script>
